export default __webpack_public_path__ + "static/media/banner-clipe.9890fbc2.webp";